import { useDispatch } from 'react-redux';
import React, { useRef } from 'react'
import { GridTable, GridController } from "@ctsu/ctsu-mui-grid";
import { getToken } from "@ctsu/loader";
import { useCurrentUser } from 'helpers/getAppConfig';
import { fetchPersonRoleEnum, fetchRoleTypeLov, saveSelectedMCRow } from 'stores/redux/slice/manageCommitte';
import AssociationLov from './AssociationLov';
import ObjectTypeLov from './ObjectTypeLov';
import { clone } from 'ramda';
import EditRow from './EditRow';
import { dispatchRefreshEvent } from 'helpers/utils';

const esysStatusLov = [{
  label: "ACTIVE",
  value: "ACTIVE"
},
{
  label: "INACTIVE",
  value: "INACTIVE"
}
]

export default function Browser({ rows, rosterOwnerLov, objectTypeLov, associationLov, hasEditPermission }) {
  const currentUser = useCurrentUser();
  const gridController = useRef(GridController.createController());

  const dispatch = useDispatch();
  const columns = [
    {
      filter: true,
      label: "Association",
      name: "esysId",
      title: "Association",

      type: "custom-list",
      renderCustomFilter: () => (
        <AssociationLov name="association" label="association" gridController={gridController} lov={associationLov} />
      )

    },
    {
      filter: true,
      label: "Object Type",
      name: "objectType",
      title: "Object Type",
      options: objectTypeLov || [],
      type: "custom-list",
      renderCustomFilter: () => (
        <ObjectTypeLov name="objectType" label="objectType" gridController={gridController} lov={objectTypeLov} />
      )

    },
    {
      filter: true,
      label: "Owner",
      name: "owner",
      title: "Owner",
      type: "object",
      options: clone(rosterOwnerLov) || []
    },
    {
      filter: true,
      label: "Description",
      name: "description",
      title: "Description"
    },
    {
      filter: true,
      label: "Status",
      name: "esysStatus",
      title: "Status",
      type: "object",
      options: esysStatusLov
    },
    {
      filter: true,
      label: "Status Date",
      name: "statusDate",
      title: "Status Date",
      type: "date"
    },
    {
      filter: true,
      label: "Comments",
      name: "comments",
      title: "Comments"
    }
  ]
  return (
    <section>
      <GridTable
        user={currentUser}
        id="operationId"
        rows={rows}
        title="Manage Committees"
        columns={columns}
        toPdf={false}
        filterable
        enableInfiniteScroll={false}
        controller={gridController.current}
        sortable
        showFilterByDefault
        enableToolbar
        highlightRow={0}
        recordPerPage={10}
        getToken={getToken}
        tag="mc-browser"
        editable
        rowEditable={() => hasEditPermission}
        editMode={hasEditPermission}
        allowAddRow
        addRowLabel="Committee"
        addRowTitle="Add a committee"
        customFilterButtons={() => (
          <button className="grid-fn-btn" onClick={() => dispatchRefreshEvent()} type="button" title="Reset Filters">
            Reset Filters
          </button>
        )}
        generateToolTip={(rowData) => `Edit the ${rowData.esysId}`}
        renderEditRow={(row, setEditing) => (
          <EditRow
            row={row}
            setEditing={setEditing}
            existingRecord={rows}
            rosterOwner={rosterOwnerLov}
            objectTypeLov={objectTypeLov}
            associationLov={associationLov}
            esysStatusLov={esysStatusLov}
          />
        )}

        onDataLoad={(res) => {
          if (res && res.data) {
            let selected = res.data[0];
            if (selected && selected.id) {
              gridController.current.highlightRow(0);
              dispatch(fetchPersonRoleEnum(selected.id));
              dispatch(saveSelectedMCRow(selected));
              dispatch(fetchRoleTypeLov(selected.owner));
            } else {
              dispatch(fetchPersonRoleEnum());
              dispatch(saveSelectedMCRow({}));
            }
          }
        }}
        onRowClicked={(rowData) => {
          if (rowData && rowData.id) {
            dispatch(fetchPersonRoleEnum(rowData.id));
            dispatch(saveSelectedMCRow(rowData));
            dispatch(fetchRoleTypeLov(rowData.owner));
          }
        }}

      />
    </section>
  )
}
